// EventModal.tsx
import React from "react";

import { Event } from "0.Mine/3.Interfaces/Event";

import { useEventModalStyles } from "../Logic/EventModalLogic";
import { EventModalUI } from "../UI/EventModalUI";

export interface EventModalProps {
  event: Event;
  onClose: () => void;
  onEdit: () => void;
  onDelete: (id: string) => void;
}

export const EventModal: React.FC<EventModalProps> = ({ event, onClose, onEdit, onDelete }) => {
  const { styles } = useEventModalStyles();

  return (
    <EventModalUI
      event={event}
      onClose={onClose}
      onEdit={onEdit}
      onDelete={onDelete}
      styles={styles}
    />
  );
};

export default EventModal;
